import React, { useMemo, useState } from 'react';

import UserDetail from '@/components/UsersSearch/components/UserDetail';
import { UserType } from '@/types/schema';

import AutocompleteSearch from '../AutocompleteSearch';
import useUsers from './hooks/useUsers';
import { UserSearchProps } from './types';

function UserSearch({
  placeholder,
  renderStartAdornment,
  renderEndAdornment,
  onChange,
  excludedUsers = [],
  disabled,
  defaultUser,
  renderOption = (user: UserType) => {
    return <UserDetail key={user.id} user={user as UserType} />;
  },
  fixedUsers = [],
  closeIcon,
  popupIcon,
  userTypes,
  groupIds,
  initalValue,
  PopperComponent,
  classes,
  className,
  size = 'large',
  crossSubWorkspace,
  clearable = false,
  ...rest
}: UserSearchProps) {
  const [searchText, setSearchText] = useState<string>('');
  const { data: users, fetchMore } = useUsers({
    searchText,
    userTypes,
    groupIds,
    crossSubWorkspace,
  });
  const filteredUsers = useMemo(
    () => [...fixedUsers, ...users.filter((user) => !excludedUsers.includes(user.id))],
    [excludedUsers, fixedUsers, users],
  );

  return (
    <AutocompleteSearch
      PopperComponent={PopperComponent}
      className={className}
      classes={classes}
      closeIcon={closeIcon}
      data={filteredUsers}
      data-id="user-search"
      defaultValue={defaultUser}
      disableClearable={!clearable}
      disabled={disabled}
      fetchMore={fetchMore}
      getOptionLabel={(value) => (value?.name || value?.uniqueId) ?? ''}
      initialValue={initalValue}
      placeholder={placeholder}
      popupIcon={popupIcon}
      renderers={{
        renderEndAdornment,
        renderOption,
        renderStartAdornment,
      }}
      size={size}
      onChange={onChange}
      onInputChange={setSearchText}
      {...rest}
    />
  );
}

export default UserSearch;
